import { React } from 'react';

/** Utils */
import { generateBem } from '../../../utils/generateBem';

import './Topbar.scss';
import { Button } from '../';
import { useLocation as location } from 'react-router';
import { Link } from 'react-router-dom';

/** assets */
import logo from '../../../assets/images/spero_logo_sm.png';
import icon from '../../../assets/images/spero_icon.png';

const bem = generateBem('Topbar');
const Topbar = ({ isPlans }) => {
  const { search } = location();

  return (
    <div className={bem('dropdown--wrapper')}>
      <header className="Topbar">
        <div className={`${bem('wrapper')}`}>
          <Link className={bem('wordmark')} to={{ pathname: '/home', search }}>
            <img src={logo} className={bem('companyLogo')} alt="spero desktop logo" />
          </Link>
          <Link className={bem('icon')} to={{ pathname: '/home', search }}>
            <img src={icon} className={bem('companyIcon')} alt="spero desktop logo" />
          </Link>
          <div className={bem('menu')}>
            {/* <NavLink
              to="/capital-management"
              className={bem('pricingLink')}
              activeClassName={bem('pricingLink--active')}
            >
              {'Private\nCapital'}
            </NavLink> */}
            {/* <NavLink
              to={{ pathname: '/solutions/fund-management', search }}
              className={bem('pricingLink')}
              activeClassName={bem('pricingLink--active')}
            >
              Funds
            </NavLink>
            <NavLink
              to={{ pathname: '/solutions/founders', search }}
              className={bem('pricingLink')}
              activeClassName={bem('pricingLink--active')}
            >
              Founders
            </NavLink>
            <NavLink
              to={{ pathname: '/solutions/partners', search }}
              className={bem('pricingLink')}
              activeClassName={bem('pricingLink--active')}
            >
              Partners
            </NavLink> */}
            {/* <NavLink
              to="/practice"
              className={bem('pricingLink')}
              activeClassName={bem('pricingLink--active')}
            >
              Practice
            </NavLink> */}
            {/* <NavLink
              to={{ pathname: '/plans', search }}
              className={bem(['pricingLink', isPlans ? 'pricingLink--optional' : null])}
              activeClassName={bem('pricingLink--active')}
            >
              {'Platform\nPlans'}
            </NavLink> */}
          </div>
          <div className={bem('actions')}>
            <Button
              isFlat
              buttonType="link"
              href={`https://app.paperos.com/login${search}`}
              size="sm"
            >
              Sign In
            </Button>
            <Button
              isFlat
              href={`https://share.hsforms.com/13LANhGXnQYeJrK3F44-_JA2rvzm${search}`}
              size="sm"
            >
              Contact Sales
            </Button>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Topbar;
